import { UI } from '@genial/components';

import { ProductsConstantsType } from '../../constants';
import { useGlobalAssetContext } from '../../contexts';
import { useGlobalAssetController } from '../../hooks';

export namespace AssetTabsTypes {
  export type AssetTabsProps = ProductsConstantsType & {
    id: string;
    selected: boolean;
    operationsTabs: ProductsConstantsType[];
  };
}

export const AssetTabs = () => {
  const { productsTabs, selectedTabIndex } = useGlobalAssetContext();
  const { handleChangeTab } = useGlobalAssetController();

  return (
    <UI.Tabs
      testId="assets-tabs"
      activeTab={selectedTabIndex}
      onTabPress={handleChangeTab}
      tabs={productsTabs}
    />
  );
};
